<template lang="pug">
	.panel(v-if="!remove" :class="[{ 'panel-expand': expand, 'panel-loading': reload }, panelTheme, panelClass]")
		.panel-heading
			slot(name="header")
			h4.panel-title(v-if="!hasHeaderSlot") {{ title }}
			.panel-heading-btn(v-if="!noButton")
				a.btn.btn-xs.btn-icon.btn-circle.btn-default(v-if="reportDetails == 1" @click="panelExpand")
					i.fa.fa-expand
				//- a.btn.btn-xs.btn-icon.btn-circle.btn-success(@click="panelReload")
				//- 	i.fa.fa-redo
				//- a.btn.btn-xs.btn-icon.btn-circle.btn-warning(@click="panelCollapse")
				//- 	i.fa.fa-minus
				//- a.btn.btn-xs.btn-icon.btn-circle.btn-danger(@click="panelRemove")
				//- 	i.fa.fa-times
		slot(name="beforeBody")
		.panel-body(v-if="!noBody" v-show="!collapse" :class="bodyClass")
			slot
			.panel-loader(v-if="reload")
				span.spinner-small
		slot(v-else)
		slot(name="outsideBody")
		.panel-footer(v-if="hasFooterSlot" :class="footerClass")
			slot(name="footer")
		slot(name="afterFooter")
</template>

<script>
export default {
	name: 'Panel',
	props: ['title', 'body', 'footer', 'variant', 'noBody', 'noButton', 'outsideBody', 'bodyClass', 'footerClass', 'panelClass', 'reportDetails'],
	data() {
		return {
			expand: false,
			collapse: false,
			remove: false,
			reload: false,
			panelTheme: (this.variant) ? 'panel-' + this.variant : 'panel-inverse'
		}
	},
	computed: {
		hasFooterSlot() {
			return !!this.$slots.footer;
		},
		hasHeaderSlot() {
			return !!this.$slots.header;
		}
	},
	methods: {
		panelExpand: function() {
			this.expand = !this.expand
		},
		panelCollapse: function() {
			this.collapse = !this.collapse
		},
		panelRemove: function() {
			this.remove = !this.remove
		},
		panelReload: function() {
			this.reload = true;
			setTimeout(function() {
				this.resetReload()
			}.bind(this), 2000);
		},
		resetReload: function() {
			this.reload = false;
		}
	}
}
</script>